// --------------------------------------------------------------------------
// #134 Personal plan filters: create and save
// --------------------------------------------------------------------------
// Author:      Thomas Jeatt
// Email:       tjeatt@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

/* global picturefill */

'use strict';

var $ = require('jquery');
var reinitModules = require('../../utilities/reinit-modules');

module.exports = function () {

    /// Init function from app.js
    function reinitialiseModules() {
        var modules = [{
            name: 'personal-plan-activity-completion',
            module: require('./personal-plan-activity-completion')
        }, {
            name: 'personal-plan-activities-load',
            module: require('./personal-plan-activities-load')
        }, {
            name: 'activity-filter',
            module: require('../activities/activity-filter')
        }, {
            name: 'social-reward-modal',
            module: require('../rewarding/social-reward-modal')
        }];

        reinitModules(modules);
    }

    function init() {
        var postcodeHero = $('[data-binding="personal-plan-postcode-hero"]');
        var postcodeForm = postcodeHero.find('form');
        var postcodeFormButton = postcodeForm.find('[data-binding="personal-plan-postcode-hero-button"]');
        var postcodeFormButtonLoadingText = postcodeFormButton.data('loading-text');
        var postcodeFormButtonIcon = postcodeForm.find('[data-binding="postcode-hero-button-icon"]');
        var postcodeFormUrlField = $('.postcode-hero__forward-url');
        var postcodeFormPostcodeField = $('.postcode-hero__input');

        function saveActivities() {
            var personalPlan = $('[data-binding="personal-plan"]');
            var saveActivitiesForm = personalPlan.find('form');
            var saveActivitiesButton = saveActivitiesForm.find('[data-binding="personal-plan-activities-button"]');
            var saveActivitiesButtonLoadingText = saveActivitiesButton.data('loading-text');

            saveActivitiesForm.on('submit', function (e) {
                e.preventDefault();
                saveActivitiesButton.addClass('disabled');
                saveActivitiesButton.find('.button__text').text(saveActivitiesButtonLoadingText);

                $.ajax({
                    data: saveActivitiesButton.attr('name') + '=',
                    type: saveActivitiesForm.attr('method'),
                    url: saveActivitiesForm.attr('action'),
                    success: function success(data) {
                        var $data = $(data);

                        personalPlan.replaceWith($data);

                        /// Reinitialise picturefill
                        if (typeof window.HTMLPictureElement !== 'function') {
                            picturefill();
                        }

                        reinitialiseModules();
                    }
                });
            });
        }

        function filterActivities() {
            var personalPlan = $('[data-binding="personal-plan"]');
            var activityFilter = $('[data-binding="activity-filter"]');
            var activityFilterForm = activityFilter.find('form');
            var activityFilterButton = activityFilterForm.find('[data-binding="activity-filter-button"]');
            var activityFilterButtonLoadingText = activityFilterButton.data('loading-text');

            activityFilterForm.on('submit', function (e) {
                e.preventDefault();
                activityFilterButton.addClass('disabled');
                activityFilterButton.find('.button__text').text(activityFilterButtonLoadingText);

                $.ajax({
                    data: activityFilterForm.serialize() + '&' + activityFilterButton.attr('name') + '=',
                    type: activityFilterForm.attr('method'),
                    url: activityFilterForm.attr('action'),
                    success: function success(data) {
                        var $data = $(data);

                        personalPlan.replaceWith($data);
                        /// Reinitialise picturefill
                        if (typeof window.HTMLPictureElement !== 'function') {
                            picturefill();
                        }

                        saveActivities();
                    }
                });
            });
        }

        postcodeForm.on('submit', function (e) {
            var userPostcode = postcodeFormPostcodeField.val().replace(/\s+/g, '');
            var forwardUrl = postcodeFormUrlField.attr('value');
            var targetUrl = forwardUrl + '?postcode=' + userPostcode;

            e.preventDefault();
            postcodeFormButton.addClass('disabled');
            postcodeFormButton.find('.button__text').text(postcodeFormButtonLoadingText);
            /// Icon removed to prevent loading text breaking layout
            postcodeFormButtonIcon.remove();

            $.ajax({
                data: 'MyPersonalPlanFilters=',
                type: postcodeForm.attr('method'),
                url: targetUrl,
                success: function success(data) {
                    postcodeHero.replaceWith($(data).find('[data-binding="activity-listing"]'));
                    filterActivities();
                    reinitialiseModules();
                }
            });
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/personal-plan/personal-plan-create.js
// module id = 253
// module chunks = 0